import { useEffect, useState } from 'react';
import { RequestState } from '../components/RequestState';
import { createOrganizerDataApi, fetchOrganizerAccess, type OrganizerDataApi } from './api';
import { createHandshake } from './handshake';
import { parseParentOrigins } from './parentOrigins';
import { OrganizerRemarketingPage } from './OrganizerRemarketingPage';
import { createOrganizerSession, type OrganizerSession } from './session';

// Entrada /organizer/remarketing. A sessão nasce e morre com a rota: listeners,
// timers e o token em memória são descartados na desmontagem (inclusive na
// remontagem dupla do StrictMode), então não há emissão duplicada nem token
// sobrevivendo à tela.

/** Lista do build (VITE_*): pública, sem segredo. Ausente/inválida → área desabilitada. */
const parentOrigins = parseParentOrigins(import.meta.env.VITE_ORGANIZER_PARENT_ORIGINS);

function createBrowserSession(): OrganizerSession {
  const allowedOrigins = parentOrigins.status === 'ok' ? parentOrigins.origins : [];
  return createOrganizerSession({
    parentOrigins,
    embedded: window.parent !== window,
    createHandshake: (onParentReady) =>
      createHandshake({ self: window, parent: window.parent, allowedOrigins, onParentReady }),
    fetchAccess: (token, signal) => fetchOrganizerAccess(token, signal),
    visibility: document,
  });
}

export function OrganizerRemarketingRoute() {
  const [runtime, setRuntime] = useState<{ session: OrganizerSession; api: OrganizerDataApi } | null>(null);

  useEffect(() => {
    const session = createBrowserSession();
    setRuntime({ session, api: createOrganizerDataApi(session) });
    session.start();
    return () => session.dispose();
  }, []);

  if (!runtime) {
    return <RequestState title="Conectando ao Gestão" message="Conferindo sua sessão e seus acessos." />;
  }
  return <OrganizerRemarketingPage api={runtime.api} session={runtime.session} />;
}
